import React, { Fragment } from "react";
import CollectDonationsBanner from "assets/images/YOOZ-WEBSITE-COLLECT-DONATIONS-banner.png";
import ContentWrapper from "components/public-dashboard/components/contentWrapper";
import PageBanner from "components/public-dashboard/components/page_banner";
import PartnersContent from "./content";
import PartnersHeader from "./header";
import useDocumentTitle from "../../../../hooks/useDocumentTitle";

export default function Partners() {
    useDocumentTitle(
    "Collect Donations via Multiple Channels | YOOZ",
    "Be more accessible to your donors. Collect cash or card donations via multiple channels and your own website. Streamline and automate your accounting process."
  );
  return (
    <Fragment>
      <PageBanner img={CollectDonationsBanner} />
      <ContentWrapper>
        <PartnersHeader />
        <PartnersContent />
      </ContentWrapper>
    </Fragment>
  );
}
